import { BlocksIconMachineExcavator } from 'blocks-nextjs/blocks-web-components/components/icon/icons/machine-excavator';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMachineExcavator = createComponent({
  react: React,
  tagName: 'cat-icon-machine-excavator',
  elementClass: BlocksIconMachineExcavator
});
